import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import 'video-react/dist/video-react.css';
import { Player } from 'video-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye, faEdit, faTrashAlt, faPlus,
} from '@fortawesome/free-solid-svg-icons';

import { Card, Filter } from './styles';
import api from '../../services/api';

import Button from '../../components/Button';
import Select from '../../components/Select';
import Loading from '../../components/Loading';

export default class EventPosts extends Component {
  state = {
    alert: {},
    loading: true,
    posts: [],
    showAlert: false,
  };

  filterOptions = [
    { value: 'recent', text: 'Mais recentes' },
    { value: 'old', text: 'Mais antigos' },
    { value: 'status', text: 'Status' },
    { value: 'kind', text: 'Tipo' },
  ];

  statusTranslation = {
    scheduled: 'Agendada',
    published: 'Publicada',
    expired: 'Expirada',
  };

  static propTypes = {
    match: PropTypes.shape().isRequired,
  };

  componentDidMount() {
    this.loadPosts();
  }

  loadPosts = async () => {
    try {
      const { data } = await api.get('posts', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          event_id: this.props.match.params.id,
        },
      });

      const formated = data.posts.map(post => ({
        ...post,
        published_at: moment(post.published_at).format('DD/MM/YYYY, HH:mm[h]'),
        translated_status: this.statusTranslation[post.status],
      }));

      this.setState({ posts: formated });

      this.setState({ loading: false });
    } catch (err) {
      this.setState({ posts: {} });
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  deletePost = (id) => {
    this.setState(
      {
        alert: {
          title: 'Atenção',
          type: 'warning',
          messages: ['Tem certeza que deseja deletar esta publicação?'],
          confirmBtnText: 'Deletar',
          confirmBtnBsStyle: 'danger',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmDeletePost(id),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmDeletePost = async (id) => {
    const { posts } = this.state;
    try {
      await api.delete(`posts/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({ posts: posts.filter(post => post.id !== id) });
      this.closeAlert();
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível deletar a publicação. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      loading,
      posts,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <div>
            <h1 className="page-title">Publicações do evento</h1>
            <div className="box">
              <div style={{ display: 'none' }}>
                <div className="box-header">
                  <Filter>
                    <span>Ordenar por:</span>
                    <Select options={this.filterOptions} />
                  </Filter>
                </div>
              </div>
              {posts.length > 0 ? (
                <div className="cards-grid">
                  {posts.map(post => (
                    <Card key={post.id} className="card card-small">
                      <Link className="wrapper-link" to={`/panel/posts/${post.id}`}>
                        {post.content_kind === 'image' ? (
                          <div
                            className="card-image"
                            style={{ backgroundImage: `url(${post.image})` }}
                          />
                        ) : (
                          <Player
                            playsInline
                            src={post.video}
                            aspectRatio="auto"
                          />
                        )}
                        <div className="card-block">
                          <h4 className="card-title capitalize">{post.kind}</h4>
                          <p className="card-text">
                            <b>Data de publicação:</b> {post.published_at}
                          </p>
                          <p className="card-text">
                            <b>Descrição:</b> {post.description}
                          </p>
                          <p className="card-text">
                            <b>Status:</b>{' '}
                            <span className="capitalize">{post.translated_status}</span>
                          </p>
                        </div>
                      </Link>
                      <div className="card-buttons">
                        <Link className="btn btn-primary" to={`/panel/posts/${post.id}`}>
                          <FontAwesomeIcon icon={faEye} />
                        </Link>
                        <Link className="btn btn-success" to={`/panel/posts/${post.id}/edit`}>
                          <FontAwesomeIcon icon={faEdit} />
                        </Link>
                        <Button onClick={() => this.deletePost(post.id)} className="btn-danger">
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </Button>
                      </div>
                    </Card>
                  ))}
                </div>
              ) : (
                <h5 className="text-center">Este evento ainda não possui publicações.</h5>
              )}
            </div>
            <Link to="/panel/create-post" className="btn btn-success btn-add btn-fixed">
              <FontAwesomeIcon icon={faPlus} />
            </Link>

            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}
          </div>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EventPosts/index.js